enum VehicleCondition {
    NotSet = 0,
    New = 1,
    Used = 2,
    Both = 3
}
export default VehicleCondition;
